import './Errors.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { ReactElement } from 'react';
import { Auth } from '../../routes/config/Auth';

export const ErrorView = (): ReactElement => {
  const { t } = useTranslator();

  return (
    <div className='error-page'>
      <div>
        <h1 className='error-header'>{t('oops')}</h1>
        <p className='error-body'>
          {t('error_page_body')} <br /> {t('error_page_body2')}
        </p>
        <a
          href={Auth.Login.Path}
          rel='noreferrer'
        >
          <Button startDecorator={<FontAwesomeIcon icon='home' />}>{t('projects_header')}</Button>
        </a>
      </div>
    </div>
  );
};
